export const PRIVACY_LINK = 'https://www.aidma-hd.jp/privacy/'

export const TERMS_LINK = 'https://noco.sale/tos/'

export const PROGRESS = {
  THRESHOLD: 90,
  SPEED: 32
}
